export const getDefaults = (imports) => {
  return imports.keys().reduce((a, v) => { a[v.substr(2, v.lastIndexOf('.') - 2)] = imports(v).default; return a }, {})
}



// WEBPACK FOOTER //
// ./src/utils/importUtil.js